export default __webpack_public_path__ + "static/media/mangal (1).3eb2f121.jpg";